export const serializeDateFormatShort = (dateString) => {
  if (!dateString) return "";

  return new Date(
    dateString.replace(/\//g, "-").split("-").reverse()
  ).toLocaleDateString(undefined, {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const serializeDateFormatLong = (dateString, reverseApply = false) => {
  if (!dateString) return "";

  dateString = dateString.replace(/-/g, "/");

  if (!reverseApply) dateString = dateString.split("/");
  else dateString = dateString.split("/").reverse();

  return new Date(dateString.join("/"))
    .toLocaleDateString(undefined, {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    })
    .replace(/,/g, "");
};

export const finderProfessionalByName = (professionalsArray, name) => {
  let finder = null;
  if (name !== "") {
    finder = professionalsArray.find(
      (x) => x.ptdNombre === name || x.ptdRut === name
    );
  }

  return finder;
};

export const finderGeneroByName = (generos, name) => {
  let finder = null;
  if (name !== "") {
    finder = generos.find((x) => x.idgDescrip === name);
  }

  return finder;
};

export const finderSpecialityByName = (specialitiesArray, name) => {
  let finder = null;
  if (name !== "") {
    finder = specialitiesArray.find((x) => x.espNombre === name);
  }

  return finder;
};

export const finderCovenantByName = (covenantsArray, name) => {
  let finder = null;
  if (name !== "") {
    finder = covenantsArray.find((x) => x.nombre === name);
  }

  return finder;
};

export const finderTipoExamenByName = (tipoExamenArray, name) => {
  let finder = null;
  if (name !== "") {
    finder = tipoExamenArray.find((x) => x.ptD_NOMBRE === name);
  }

  return finder;
};

export const finderExamenByName = (examenArray, name) => {
  let finder = null;
  if (name !== "") {
    finder = examenArray.find((x) => x.prS_DESCRIP === name);
  }

  return finder;
};

export const finderSucursalByName = (sucursalesArray, name) => {
  let finder = null;
  if (process.env.REACT_APP_SEDE == "Puerto Montt") {
    if (name !== "") {
      //finder = sucursalesArray.find(x => x.serNombre === name);
      finder = sucursalesArray.find((x) => x.sueNombre === name);
    }
  } else {
    if (name !== "") {
      finder = sucursalesArray.find((x) => x.sueNombre === name);
    }
  }

  // let finder = null;
  // if (name !== '') {
  //     finder = sucursalesArray.find(x => x.sueNombre === name);
  // }

  return finder;
};

export const finderServicioByName = (serviciosArray, name) => {
  let finder = null;
  if (name !== "") {
    finder = serviciosArray.find((x) => x.aseDescrip === name);
  }

  return finder;
};

export const finderProcedimientoByName = (procedimientosArray, name) => {
  let finder = null;
  if (name !== "") {
    finder = procedimientosArray.find((x) => x.exaDescrip === name);
  }
  return finder;
};

export const validateEmail = (email) => {
  ////const regExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //const regExp = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
  const regExp = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,3}$/i;
  const evaluateExp = regExp.test(String(email).toLowerCase());
  return !evaluateExp
    ? {
        ok: false,
        message: `${email} no es válido`,
      }
    : {
        ok: true,
      };
};

export const validatePhone = (phone) => {
  const regExp = /^[0-9]+$/;
  const evaluateExp = regExp.test(String(phone));
  return !evaluateExp
    ? {
        ok: false,
        message: `${phone} no es válido, ingrese sólo números`,
      }
    : {
        ok: true,
      };
};

export const formatRut = (rut) => {
  let actual = rut.replace(/^0+/, "");

  if (actual.length < 8 || actual.length > 9) {
  }

  if (actual !== "" && actual.length > 0) {
    let sinPuntos = actual.replace(/\./g, "");
    let actualLimpio = sinPuntos.replace(/-/g, "");
    let inicio = actualLimpio.substring(0, actualLimpio.length - 1);
    let rutPuntos = "";
    let i = 0;
    let j = 1;
    for (i = inicio.length - 1; i >= 0; i--) {
      let letra = inicio.charAt(i);
      rutPuntos = letra + rutPuntos;
      if (j % 3 === 0 && j <= inicio.length - 1) {
        rutPuntos = "." + rutPuntos;
      }
      j++;
    }
    let dv = actualLimpio.substring(actualLimpio.length - 1);
    rutPuntos = rutPuntos + "-" + dv;

    return rutPuntos;
  }
};

export const cleanRut = (value) => {
  return value.replace(/^0+|[^0-9kK]+/g, "").toUpperCase();
};

export const validateRutChilean = (rutParam) => {
  if (
    rutParam === null ||
    rutParam === undefined ||
    rutParam === "" ||
    rutParam.length < 3
  ) {
    return {
      ok: false,
      message: `no valido rut`,
    };
  }
  rutParam = rutParam.toString();
  if (!rutParam.includes("-")) {
    let endChar = rutParam[rutParam.length - 1];
    rutParam = `${rutParam.substr(0, rutParam.length - 1)}-${endChar}`;
  }

  let rut = rutParam.replace(/\./g, "");
  let rutSplit = rut.split("-");

  let arrayRut = rutSplit[0].split("");

  let rutLength = arrayRut.length - 1;
  let indexUp = 2;
  let sumValues = 0;

  arrayRut.forEach((el, index) => {
    if (indexUp > 7) {
      indexUp = 2;
    }

    sumValues += Number(arrayRut[rutLength]) * indexUp;
    indexUp++;

    if (rutLength >= 0) {
      rutLength--;
    }
  });

  let rest = Math.ceil(sumValues % 11);

  let dv = null;

  if (11 - rest === 10) {
    dv = "K";
  } else if (11 - rest >= 1 && 11 - rest <= 9) {
    dv = (11 - rest).toString();
  } else if (11 - rest === 11) {
    dv = "0";
  } else {
    dv = "";
  }

  let validarRUT = rut.replace("-", "");
  if (validarRUT.length < 8 || validarRUT.length > 9) {
    return {
      ok: false,
      message: `no valido rut`,
    };
  }

  return dv === "" || dv !== rutSplit[1].toUpperCase()
    ? {
        ok: false,
        message: `El rut ${rut} no es valido`,
      }
    : {
        ok: true,
      };
};

export const parseJwt = (token) => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};

export const getExpiresToken = (expirationTime) => {
  let nowDate = Date.now() / 1000;
  let exp = expirationTime;
  return Math.ceil((exp - nowDate) * 1000);
};

export const addDays = (days) => {
  var result = new Date();
  result.setDate(result.getDate() + days);
  return result;
};

export const haveLetterLower = (text) => {
  return /^(?=.*[a-z]).*$/.test(text);
};

export const haveLetterUpper = (text) => {
  return /^(?=.*[A-Z]).*$/.test(text);
};

export const haveNumber = (text) => {
  return /^(?=.*[0-9]).*$/.test(text);
};

export const lengthValid = (text) => {
  return text.length >= 8;
};

export const removeNumbers = (valueString) => {
  return valueString.replace(/[0-9]/g, "");
};

export const removeLettersAndCharactersSpecials = (valueString) => {
  return valueString
    .replace(/[a-zA-Z]/g, "")
    .replace(/[^\w\s]/gi, "")
    .replace(/ /g, "");
};

export const removeCharactersSpecials = (valueString) => {
  return valueString.replace(/[^\w\s\u00f1\u00d1\u00C0-\u00FF]/gi, "");
};

export const capitalizeWord = (word) => {
  return word
    .split("")
    .map((letter, index) =>
      index ? letter.toLowerCase() : letter.toUpperCase()
    )
    .join("");
};

export const capitalizeWords = (str) => {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const isSexFemale = (sex) => {
  return sex && sex.toLowerCase().startsWith("f");
};

export const isSexMale = (sex) => {
  return sex && sex.toLowerCase().startsWith("m");
};

export const isSexIndeterminate = (sex) => {
  return sex && sex.toLowerCase().startsWith("i");
};

export const timeoutAsync = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const isValidDate = (dateString) => {
  const d = new Date(dateString);
  if (Object.prototype.toString.call(d) === "[object Date]") {
    if (isNaN(d.getTime())) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};

export const formatDateISOString = (dateString) => {
  return dateString?.toISOString().replace(/-/g, "/").replace("T", " ");
};

//----
export const nameSede = (sede) => {
  let ubicacion = sede;
  let nombreSede = "";
  if (ubicacion == "Puerto Montt") {
    nombreSede = "Clínica Andes Salud " + sede;
  } else if (ubicacion == "Concepción") {
    nombreSede = "Clínica Andes Salud " + sede;
  } else if (ubicacion == "Chillán") {
    nombreSede = "Clínica Andes Salud " + sede;
  } else if (ubicacion == "Calama") {
    nombreSede = "Clínica Andes Salud " + sede;
  } else if (ubicacion == "Los Ángeles") {
    nombreSede = "Centro Médico Andes Salud " + sede;
  } else if (ubicacion == "Talca") {
    nombreSede = "Centro Médico Andes Salud " + sede;
  } else if (ubicacion == "Ancud") {
    nombreSede = "Centro Médico Andes Salud " + sede;
  }

  return nombreSede;
};

export const emailValidator = (value) => {
  let arroba = value.indexOf("@");
  let punto = value.indexOf(".");

  if (arroba == -1) {
    value = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    if (punto == -1) {
      value = value.replace(/[^\w ]/g, "");
    } else {
      let txtArr = value.split(".");
      let subText = txtArr[txtArr.length - 1];
      subText = subText
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^\w ]/g, "");

      let txtFinal = "";
      txtArr.pop();
      txtArr.push(subText);
      txtFinal = txtArr.join(".");
      value = txtFinal;
    }
  } else {
    let mailFinal = "";
    let mailArr = value.split("@");
    let userMail = mailArr[0];
    let domainMail = mailArr[1];
    let puntoDomain = domainMail.indexOf(".");
    if (puntoDomain == -1) {
      let subDomainText = mailArr[1];
      subDomainText = subDomainText
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^\w ]/g, "");

      mailArr.pop();
      mailArr.push(subDomainText);

      mailFinal = mailArr.join("@");
      value = mailFinal;
    } else {
      let txtArr = domainMail.split(".");
      let subText = txtArr[txtArr.length - 1];
      subText = subText
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^\w ]/g, "");
      let txtFinal = "";
      txtArr.pop();
      txtArr.push(subText);
      txtFinal = txtArr.join(".");
      mailFinal = userMail + "@" + txtFinal;
      value = mailFinal;
    }
  }
  return value;
};

export const slugQuery = (text = "") => {
  return text
    .normalize("NFD") // separa acentos
    .replace(/[\u0300-\u036f]/g, "") // elimina acentos
    .replace(/ñ/gi, "n") // reemplaza ñ → n
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-") // espacios → guiones
    .replace(/[^\w\-]/g, ""); // elimina caracteres raros
};
